/**
 * 方法快速查阅：
 *
 * 检测：
 * hasOwn（object, key） 是否含有属性
 * isArray（object） 数组检测
 * isFunction（val）
 * isString（val）
 * isSymbol（val）
 * isObject（val）
 * isPromise（val）
 * isPhone（val）
 * isEmail（val）
 *
 * 四则运算：
 * Add（）加
 * Sub（）减
 * Mul（）乘
 * Div（）除
 *
 * 应用函数：
 * toFixed (n) 四舍五入保留几位小数
 * toFixedFloor (n) 非四舍五入，向下取保留几位小数
 * orderByList (list, k, desc) list排序
 * getParamUrl (variable) 获取地址栏参数值
 * filterStr (str) 特殊字符过滤
 * loadScript (url, callback) 异步加载script
 * deep_copy (data) 深拷贝
 * get (obj, props, def) 获取对象属性值
 * on(event, callback, [boolern]) 事件监听
 * off(event, callback) 事件移除
 * sort(a, b) list排序sort函数
 * debounce(func, wait, immediate) 防抖函数
 * throttle(func, wait, type) 节流函数
 * initFontSize() H5字体自适应
 *
 * web安全：
 * isIframe() iframe检测
 * HTMLEncode(html) html编码
 * HTMLDecode(text) html解码
 * isSqlSafe(vel) sql注入检测
 *
 * getFingerCode() 获取设备指纹码
 *
 */

// const FingerPrint = require('./../../assets/js/fingerprint2.min.js')

const hasOwnProperty = Object.prototype.hasOwnProperty;
export const hasOwn = (
    val: object,
    key: string | symbol
): key is keyof typeof val => hasOwnProperty.call(val, key);

export const isArray = Array.isArray;
export const isFunction = (val: any): val is Function =>
    typeof val === "function";
export const isString = (val: any): val is string => typeof val === "string";
export const isSymbol = (val: any): val is symbol => typeof val === "symbol";
export const isObject = (val: any): val is Record<any, any> =>
    val !== null && typeof val === "object";

export const isPromise = (obj: any) => {
    return (
        !!obj &&
        (typeof obj === "object" || typeof obj === "function") &&
        (typeof obj.then === "function" || typeof obj.catch === "function")
    );
};

export function isPhone(str: string | number) {
    return /^[0-9]+$/.test(isString(str) ? str : str.toString());
}
export function isEmail(str: string) {
    if (str.indexOf("@") !== -1) {
        return true;
    }
}

//四则运算中间件
function calcMiddle(fun: any, arg: any) {
    let args = Array.from(arg);
    if (args.length > 2) {
        return fun.apply(
            this,
            [fun.apply(this, args.slice(0, 2))].concat(args.slice(2))
        );
    }
}
//加法运算 eg: Add(1, "2", 3, 4, 5); return 16
export function Add(): number {
    if (calcMiddle(Add, arguments)) return calcMiddle(Add, arguments);
    let arg1 = (arguments[0] || 0).toString();
    let arg2 = (arguments[1] || 0).toString();
    let arg1Arr = arg1.split(".");
    let arg2Arr = arg2.split(".");
    let d1 = arg1Arr.length == 2 ? arg1Arr[1] : "";
    let d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
    let maxLen = Math.max(d1.length, d2.length);
    let m = Math.pow(10, maxLen);
    return Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
}
//减法运算 eg: Sub(1, "2", 3, 4, 5); return -13
export function Sub(): number {
    if (calcMiddle(Sub, arguments)) return calcMiddle(Sub, arguments);
    let arg1 = (arguments[0] || 0).toString();
    let arg2 = (arguments[1] || 0).toString();
    return Add.call(this, arg1, -Number(arg2));
}
//乘法运算 eg: Sub(1, "2", 3, 4, 5); return 120
export function Mul(): number {
    if (calcMiddle(Mul, arguments)) return calcMiddle(Mul, arguments);
    let r1 = (arguments[0] || 0).toString();
    let r2 = (arguments[1] || 0).toString();
    let m;
    let resultVal;
    m =
        (r1.split(".")[1] ? r1.split(".")[1].length : 0) +
        (r2.split(".")[1] ? r2.split(".")[1].length : 0);
    resultVal =
        (Number(r1.replace(".", "")) * Number(r2.replace(".", ""))) /
        Math.pow(10, m);
    return resultVal;
}
//除法运算 eg: Div(1, "2", 3, 4, 5); return 0.008333333333333333
export function Div(): number {
    if (calcMiddle(Div, arguments)) return calcMiddle(Div, arguments);
    let r1 = (arguments[0] || 0).toString();
    let r2 = (arguments[1] || 0).toString();
    let m;
    m =
        (r2.split(".")[1] ? r2.split(".")[1].length : 0) -
        (r1.split(".")[1] ? r1.split(".")[1].length : 0);
        
    return Mul.call(this,(Number(r1.replace(".", "")) / Number(r2.replace(".", ""))),Math.pow(10, m));
}

/**
 * 四舍五入
 * @param {Number} n
 */
export function toFixed(n: any): string {
    // console.log(n);
    if (n > 20 || n < 0) {
        throw new RangeError(
            "toFixed() digits argument must be between 0 and 20"
        );
    }

    var number = this;

    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }

    //防止科学计数法出现
    number = Number(number);

    if (typeof n == "undefined" || n == 0) {
        return Math.round(number).toString();
    }

    var result = number.toString();
    var arr = result.split("."); // 整数的情况

    if (arr.length < 2) {
        result += ".";

        for (var i = 0; i < n; i += 1) {
            result += "0";
        }

        return result;
    }

    var integer = arr[0];
    var decimal = arr[1];

    if (decimal.length == n) {
        return result;
    }

    if (decimal.length < n) {
        for (var _i = 0; _i < n - decimal.length; _i += 1) {
            result += "0";
        }

        return result;
    }

    result = integer + "." + decimal.substr(0, n);
    var last = decimal.substr(n, 1); // 四舍五入，转换为整数再处理，避免浮点数精度的损失

    if (parseInt(last, 10) >= 5) {
        var x = Math.pow(10, n);
        result = (Math.round(parseFloat(result) * x) + 1) / x;
        result = result.toFixed(n);
    }

    return result;
}

/**
 * 非四舍五入向下取值，保留n位小数
 * @export
 * @param {Number} n
 * @returns String
 */
export function toFixedFloor(n: any): string {
    if (n > 20 || n < 0) {
        throw new RangeError(
            "toFixed() digits argument must be between 0 and 20"
        );
    }

    var number = this;
    var m = n;

    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }

    //防止科学计数法出现
    number = Number(number);

    number += "";
    number =
        number && number.lastIndexOf(".") > -1
            ? number.substring(0, number.lastIndexOf(".") + ++n)
            : number;
    return number;
}
/**
 * 非四舍五入向下取值，保留n位小数
 * @export
 * @param {Number} n
 * @returns String
 */
export function toFixedFloorExtend(n: any): string {
    if (n > 20 || n < 0) {
        throw new RangeError(
            "toFixed() digits argument must be between 0 and 20"
        );
    }

    var number = this;
    var m = n;

    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }

    //防止科学计数法出现
    number = Number(number);

    number += "";
    number =
        number && number.lastIndexOf(".") > -1
            ? number.substring(0, number.lastIndexOf(".") + ++n)
            : number;
    //return number;
    return Number(number).toFixed(m);
}

/**
 * list排序 sort函数
 *
 * @export
 * @param {*} a
 * @param {*} b
 * @returns
 */
export function sort(a: any, b: any) {
    if (!window.isNaN(a) && !window.isNaN(b)) {
        return a - b;
    }
    if (typeof a == "string" && typeof b == "string") {
        return a.localeCompare(b);
    }
}

/**
 * list排序
 * @param {Array} list
 * @param {String} k
 * @param {Boolean} desc
 */
export function orderByList(list: [], k: string, desc: boolean) {
    if (list instanceof Array) {
        return list.sort(function(a: any, b: any) {
            if (!window.isNaN(a[k]) && !window.isNaN(b[k])) {
                if (desc) {
                    return a[k] - b[k];
                } else {
                    return b[k] - a[k];
                }
            }

            if (typeof a[k] == "string" && typeof b[k] == "string") {
                if (desc) {
                    return a[k].localeCompare(b[k]);
                } else {
                    return b[k].localeCompare(a[k]);
                }
            }
        });
    }
    return list;
}

/**
 * 获取地址栏指定参数
 * @param {String} variable
 */
export function getParamUrl(variable: string): any {
    if (!variable) return undefined;
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return undefined;
}

/**
 * 过滤字符串中的特殊字符
 * @param {String} str
 */
export function filterStr(str: string) {
    return (str || "").replace(
        /[\-\_\,\!\|\~\`\(\)\#\$\%\^\&\*\{\}\:\;\"\L\<\>\?]/g,
        ""
    );
}

/**
 * 异步加载外部js资源
 * @param {String} url
 * @param {Function} callback
 */
export function loadScript(url: string, callback: any) {
    var script: any = document.createElement("script");
    script.src = url;
    document.body.appendChild(script);
    if (script.addEventListener) {
        script.addEventListener(
            "load",
            function() {
                callback();
            },
            false
        );
    } else if (script.attachEvent) {
        script.attachEvent("onreadystatechange", function() {
            var target: any = window.event.srcElement;
            if (target.readyState == "loaded") {
                callback();
            }
        });
    }
}

/**
 * 异步加载外部css资源
 * @param {String} url
 * @param {Function} callback
 */
export function loadCss(url: string, callback: any) {
    var link: any = document.createElement("link");
    link.href = url;
    link.type = "text/css";
    link.rel = "stylesheet";
    document.head.appendChild(link);
    if (link.addEventListener) {
        link.addEventListener(
            "load",
            function() {
                callback();
            },
            false
        );
    } else if (link.attachEvent) {
        link.attachEvent("onreadystatechange", function() {
            var target: any = window.event.srcElement;
            if (target.readyState == "loaded") {
                callback();
            }
        });
    }
}

/**
 * 事件监听处理
 * @export
 * @param {*} event
 * @param {*} callback
 * @param {*} [boolern]
 */
export function on(event: string, callback: any, options: boolean) {
    if (window.addEventListener) {
        return this.addEventListener(event, callback, options);
    } else {
        return this.attachEvent("on" + event, callback);
    }
}

/**
 * 事件移除处理
 * @export
 * @param {*} event
 * @param {*} callback
 * @param {*} [boolern]
 */
export function off(event: string, callback: any) {
    if (window.removeEventListener) {
        return this.removeEventListener(event, callback);
    } else {
        return this.detachEvent("on" + event, callback);
    }
}

/**
 * 深拷贝
 * @param {*} data
 */
export function deep_copy(data: any) {
    return JSON.parse(JSON.stringify(data));
}

/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export function debounce(func: any, wait: number, immediate: number) {
    let timeout: any;

    return function() {
        let context = this;
        let args = arguments;

        if (timeout) clearTimeout(timeout);
        if (immediate) {
            var callNow = !timeout;
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
            if (callNow) func.apply(context, args);
        } else {
            timeout = setTimeout(function() {
                func.apply(context, args);
            }, wait);
        }
    };
}

/**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 表时间戳版，2 表定时器版
 */
export function throttle(func: any, wait: number, type: number) {
    if (type === 1) {
        var previous = 0;
    } else if (type === 2) {
        var timeout: any;
    }
    return function() {
        let context = this;
        let args = arguments;
        if (type === 1) {
            let now = Date.now();

            if (now - previous > wait) {
                func.apply(context, args);
                previous = now;
            }
        } else if (type === 2) {
            if (!timeout) {
                timeout = setTimeout(() => {
                    timeout = null;
                    func.apply(context, args);
                }, wait);
            }
        }
    };
}

/**
 * 获取属性值
 * @param {*} obj
 * @param {String} props
 * @param {*} def
 */
export function get(obj: object, props: string, def: any) {
    if (obj == null || obj == null || typeof props !== "string") return def;
    const temp = props.split(".");
    const fieldArr = [].concat(temp);
    temp.forEach((e, i) => {
        if (/^(\w+)\[(\w+)\]$/.test(e)) {
            const matchs = e.match(/^(\w+)\[(\w+)\]$/);
            const field1 = matchs[1];
            const field2 = matchs[2];
            const index = fieldArr.indexOf(e);
            fieldArr.splice(index, 1, field1, field2);
        }
    });
    return fieldArr.reduce((pre, cur) => {
        const target = pre[cur] || def;

        if (target instanceof Array) {
            return [].concat(target);
        }
        if (target instanceof Object) {
            return Object.assign({}, target);
        }
        return target;
    }, obj);
}

/**
 * iframe 检测
 */
export function isIframe() {
    if (
        self.location.pathname == "/front/bitloan/footer" ||
        self.location.pathname == "/front/bitloan/header" ||
        self.location.pathname == "/h5/bitloan/header"
    ) {
        return false;
    }
    return top.location.hostname !== self.location.hostname;
}

/**
 * html decode
 * @param {*} html
 */
export function HTMLEncode(html: string) {
    let temp = document.createElement("div");

    let output = temp.innerHTML;

    temp.textContent != null
        ? (temp.textContent = html)
        : (temp.innerText = html);
    temp = null;
    return output;
}

/**
 * HTMLDecode
 * @param {*} text
 */
export function HTMLDecode(text: string) {
    let temp = document.createElement("div");

    let output = temp.innerText || temp.textContent;

    temp.innerHTML = text;
    temp = null;
    return output;
}

/**
 * sql注入检测
 * @param {*} vel
 */
export function isSqlSafe(vel: string) {
    let re = /select%20|update%20|delete%20|truncate%20|join%20|union%20|exec%20|insert%20|drop%20|count|’|"|;|>|<|%/i;

    return !re.test(vel); //true,合法  ；false,非法
}

/**
 * H5字体自适应
 * @param {*} vel
 */
export function initFontSize() {
    var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
    if (deviceWidth >= 750) {
        deviceWidth = 750;
    }
    if (deviceWidth <= 320) {
        deviceWidth = 320;
    }
    document.documentElement.style.fontSize = (deviceWidth / 7.5) * 2 + "px";
}

/**
 * 获取设备指纹码
 * @param {*} Object
 */
export function getFingerCode() {
    return new Promise((relsove, reject) => {
        relsove()
    });
}



// WEBPACK FOOTER //
// ./src/common/ts/share.ts